import React from "react";
import { Box, Typography } from "@mui/material";
import SeverityOfFaultsChart from "./SeverityOfFaultsChart";
import AutoResolvedChart from "./AutoResolvedChart";
import { CHART_TYPES } from "./chartConfig";
import { calculateGranularity } from "../CommonFunctions";

const BmsFaultTrends = ({ onShowDetails, startDate, endDate, globalFilters = {} }) => {
  // Calculate granularity based on date range (returns title case for UI)
  const granularity = calculateGranularity(startDate, endDate);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }}>
      {/* Section Header */}
      <Box>
        <Typography
          variant="fw400s20c000"
          sx={{
            lineHeight: "28px",
            fontWeight: 300,
          }}
        >
          Battery System Fault Trends
        </Typography>
      </Box>

      {/* Charts Container */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        <SeverityOfFaultsChart
          onDetailsClick={() => onShowDetails(CHART_TYPES.SEVERITY, granularity)}
          startDate={startDate}
          endDate={endDate}
          hierarchicalLocation={globalFilters?.hierarchicalLocation}
          fleetIds={globalFilters?.fleets}
          onboardingLocations={globalFilters?.onboardingLocations}
          allOnboardingLocations={globalFilters?.allOnboardingLocations}
          alertCategories={globalFilters?.alertCategories}
          operationalStatus={globalFilters?.operationalStatus}
        />
        <AutoResolvedChart
          onDetailsClick={() => onShowDetails(CHART_TYPES.AUTO_RESOLVED, granularity)}
          startDate={startDate}
          endDate={endDate}
          hierarchicalLocation={globalFilters?.hierarchicalLocation}
          fleetIds={globalFilters?.fleets}
          onboardingLocations={globalFilters?.onboardingLocations}
          allOnboardingLocations={globalFilters?.allOnboardingLocations}
          alertCategories={globalFilters?.alertCategories}
          operationalStatus={globalFilters?.operationalStatus}
        />
      </Box>
    </Box>
  );
};

export default BmsFaultTrends;
